import { z } from 'zod';
/** docs/architecture screen "Reports — Sales overview". `days` selects the
 * current period; the previous period of equal length (immediately before
 * it) is computed automatically for the comparison deltas — the design
 * canvas shows this as "Q3 2026" vs "Q2 2026", a fixed fiscal-quarter
 * picker isn't real data-model concept here, so a rolling window plays the
 * same role without inventing a calendar. */
export const salesOverviewQuerySchema = z.object({
    days: z.coerce.number().int().min(7).max(365).default(90),
});
export const funnelStageSchema = z.object({
    key: z.enum(['leads', 'contacted', 'qualified', 'deals', 'won']),
    label: z.string(),
    count: z.number().int(),
});
export const revenueMonthSchema = z.object({
    month: z.string(), // "2026-07"
    label: z.string(), // "Jul"
    value: z.string(), // decimal, as string like the rest of the app's money fields
});
export const sourceAttributionRowSchema = z.object({
    sourceId: z.string().uuid().nullable(),
    sourceName: z.string(),
    leads: z.number().int(),
    qualifiedPct: z.number(),
    deals: z.number().int(),
    wonValue: z.string(),
    avgDaysToClose: z.number().nullable(),
});
export const repWinRateRowSchema = z.object({
    membershipId: z.string().uuid(),
    displayName: z.string(),
    won: z.number().int(),
    closed: z.number().int(),
    winRatePct: z.number(),
});
export const salesOverviewResponseSchema = z.object({
    days: z.number().int(),
    funnel: z.array(funnelStageSchema),
    wonRevenueTotal: z.string(),
    wonRevenueChangePct: z.number().nullable(),
    revenueByMonth: z.array(revenueMonthSchema),
    sourceAttribution: z.array(sourceAttributionRowSchema),
    repWinRates: z.array(repWinRateRowSchema),
    teamWinRatePct: z.number(),
});
//# sourceMappingURL=schemas.js.map